import { createUseStyles } from "react-jss";
import { colors } from "../../../../../constants/colors";
import { breakpoints } from "../../../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  input: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    minHeight: "120px",
    margin: "0 auto",
    position: "relative",
    boxSizing: "border-box",
    transition: "all .15s linear",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px 24px", 
    fontSize: "14px",
    cursor: "pointer",
    "& a": {
      color: `${theme.colors.primary} !important`,
      fontWeight: "600",
      lineHeight: "20px"
    },
    "& p": {
      marginBottom: "4px"
    }
  },
  uploadIcon: {
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    height: "40px",
    width: "40px",
    padding: "10px",
    marginRight:"16px",
    border: theme.icon.border,
    borderRadius: theme.icon.borderRadius,
    boxShadow: theme.icon.boxShadow,
    backgroundColor: theme.icon.backgroundColor,
    "& svg": {
      display: "flex"
    }
  },
  csvText: {
    fontSize: "12px",
    lineHeight: "18px"
  },
  iconColor: {
    "& path": {
      stroke: theme.icon.stroke
    }
  }
}))

export default styles;
